/* global firebase drupalSettings jQuery err */

firebase.initializeApp(drupalSettings.firebaseConfig);
document.addEventListener('DOMContentLoaded', function () {
	// Div contenant le bandeau firefox
	const webpushPopup = document.getElementById('banner-modulo-notif');

	/**
	 * Simple fonction de création de cookie qui n'expire jamais
	 * @param name
	 * @param value
	 */
	const createCookie = function (name, value) {
		const expires =
			'; expires=' + new Date(2147483647 * 1000).toUTCString();
		document.cookie = name + '=' + value + expires + '; path=/';
	};

	/**
	 * lecture de cookie
	 * @param name
	 * @returns {string|null}
	 */
	const readCookie = function (name) {
		const nameEQ = name + '=';
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0)
				return c.substring(nameEQ.length, c.length);
		}
		return null;
	};

	/**
	 * Fonction en charge de la demande de permission, lié à l'API Firebase, envoie en ajax le token à drupal
	 */
	const getToken = function () {
		if (notifStatut == null) {
			messaging
				.requestPermission()
				.then(function () {
					// get the token in the form of promise
					return messaging.getToken();
				})
				.then(function (token) {
					jQuery
						.post('/modulo-notif/save', { token: token })
						.fail(function (xhr, status, error) {
							console.warn(err);
						});
					// on notifie via cookie que le droit a déjà été demandé et transmis à drupal
					createCookie(notifCookieName, 1);
					if (navigator.userAgent.indexOf('Firefox') !== -1) {
						// Pour firefox un token granted déclenche la disparition du bandeau
						webpushPopup.style.display = 'none';
					}
				})
				.catch(function (err) {
					console.warn(err);
				});
		}
	};

	// Ci après les 4 cas de figure qui font que les push notif ne marcheront pas.

	if (!('serviceWorker' in navigator)) {
		console.warn('Service workers non supportées par ce navigateur.');
		return;
	}

	if (!('PushManager' in window)) {
		console.warn('Notifications non supportées par ce navigateur.');
		return;
	}

	if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
		console.warn('Notifications non supportées par ce navigateur.');
		return;
	}

	if (Notification.permission === 'denied') {
		console.warn('Notifications non autorisées pour cet utilisateur');
		return;
	}

	// s'il a passé toutes les épreuves on débute !
	let displayBlockNotif = false;

	let notifCookieName = 'notifStatut';
	if (drupalSettings.user.uid !== 0) {
		notifCookieName = 'notifStatut-' + drupalSettings.user.uid;
	}

	const notifStatut = readCookie(notifCookieName);
	const messaging = firebase.messaging();
	const permissionStatut = Notification.permission;

	if (
		navigator.userAgent.indexOf('Firefox') !== -1 &&
		notifStatut == null &&
		permissionStatut !== 'granted'
	) {
		// Firefox demande un action, un clic pour autoriser les notifs donc il nous faut un bandeau
		displayBlockNotif = true;
	}

	if (displayBlockNotif) {
		webpushPopup.style.display = 'block';
		const webpushNoThanksButton = document.getElementById(
			'modulo-notif-no-thanks'
		);
		const webpushYesButton = document.getElementById('modulo-notif-yes');
		webpushNoThanksButton.addEventListener('click', function () {
			createCookie(notifCookieName, 2);
			webpushPopup.style.display = 'none';
		});
		webpushYesButton.addEventListener('click', function () {
			getToken();
		});
	} else {
		getToken();
	}

	// Gestion des messages reçus en foreground
	messaging.onMessage(function (payload) {
		console.log('Message received. ', payload);
		const notification = JSON.parse(payload.data.notification);
		navigator.serviceWorker.getRegistrations().then((registration) => {
			registration[0].showNotification(notification.title, {
				body: notification.body,
				data: { url: payload.data.url },
			});
		});
	});
});
